import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import { duration as durationFn, short } from 'utils/time.util'

import { IUseUserInfoProps } from './types'

const useUserInfo = ({ createdAt }: IUseUserInfoProps) => {
  const { locale } = useRouter()
  const { t } = useTranslation(['message'])

  const commentTime = useMemo(() => {
    const time = new Date(createdAt).getTime()
    const duration = durationFn(time)

    if (duration && (duration.weeks || duration.days)) {
      return short(time, locale)
    }

    if (duration && !Number(duration?.days)) {
      if (duration && Number(duration.minutes) >= 0 && !duration.hours) {
        return duration.minutes < 3
          ? t('justNow', { ns: 'message' })
          : `${duration.minutes}m ago`
      }

      if (duration && duration.minutes && duration.hours) {
        return `${duration.hours}h ago`
      }
    }

    return short(time, locale)
  }, [locale, createdAt, t])

  return { t, commentTime }
}

export default useUserInfo
